/* global setTimeout */
import { ElMessage } from 'element-plus';
import { get, post } from '../service/Http';
import qs from 'qs';

interface LoginParams {
  username: string;
  password: string;
}

interface AuthResponse {
  access_token?: string;
  token_type?: string;
  refresh_token?: string;
  expires_in?: number;
  scope?: string;
  message?: string;
  code?: number;
}

export const getAuthToken = async (params: any) => {
  console.log('getAuthToken 请求参数:', params);

  // 使用 qs 库将参数转换为 application/x-www-form-urlencoded 格式
  const formData = qs.stringify(params);

  console.log('getAuthToken 转换后的数据:', formData);

  const res = await post({
    url: '/auth/oauth2/token',
    data: formData,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + window.btoa('acc:acc')
      }
    }
  });

  console.log('getAuthToken 响应结果:', res);
  return res.data;
};

// 登录接口
export const getUsrInfo = async () => {
  // 模拟网络延迟
  // await new Promise(resolve => setTimeout(resolve, 1000));
  const res = await get({
    url: '/admin/user/info'
  });

  console.log('getUsrInfo', res.data);

  // // mock数据
  // const mockUsers = [
  //   {
  //     username: 'admin',
  //     password: '123456',
  //     userInfo: {
  //       id: '1',
  //       username: 'admin',
  //       nickname: '管理员',
  //       avatar: 'https://via.placeholder.com/100x100'
  //     }
  //   },
  //   {
  //     username: 'user',
  //     password: '123456',
  //     userInfo: {
  //       id: '2',
  //       username: 'user',
  //       nickname: '普通用户',
  //       avatar: 'https://via.placeholder.com/100x100'
  //     }
  //   }
  // ];

  // const user = mockUsers.find(
  //   u => u.username === params.username && u.password === params.password
  // );

  // if (!user) {
  //   return Promise.resolve({
  //     code: 400,
  //     message: '用户名或密码错误',
  //     data: {
  //       token: ''
  //     }
  //   });
  // }

  return res.data;
};

// 获取主应用仪表盘菜单
export const getMainAppMenuList = async (params: any) => {
  const menuList = await get({
    url: '/admin/menu',
    params: params
  });
  console.log('getMainAppMenuList', menuList.data);
  return menuList.data;
};

// 退出登录
export const logoutApi = async () => {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 500));

  ElMessage.success('退出成功');

  return Promise.resolve({
    code: 0,
    message: '退出成功',
    data: null
  });
};

// 获取不同租户的logo
export const getTenantLogo = async (params: any) => {
  const logo = await get({
    url: `/admin/tenant/details/${params.id}`,
  });
  return logo.data;
};